import { render } from "./NewTDATariffs.vue?vue&type=template&id=6c3a798e&scoped=true"
import script from "./NewTDATariffs.vue?vue&type=script&lang=js"
export * from "./NewTDATariffs.vue?vue&type=script&lang=js"

import "./NewTDATariffs.vue?vue&type=style&index=0&id=6c3a798e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3a798e"]])

export default __exports__